import styled from '@emotion/styled';

const MDXStyledStrong = styled.strong`
  font-weight: 600;
`;

export default MDXStyledStrong;
